class Btn_oneClickPopup {
	constructor() {
		this.selectors = {
			document: document,
			oneClickPopup: '.js-one-click-popup',							
		};
		this.init();
		this.events();
	};
	init() {
		this.getNodes();
	}

	getNodes() {
		var _this = this;
		this.nodes = {};
		$.each(this.selectors, function(key, selector) {
			_this.nodes[key] = $(selector);
		});
	}

	events() {
		const self = this;

		// Product button opens one-click-popup
		this.nodes.document.on('click', this.selectors.oneClickPopup, (e) => {
			const $product = $(e.currentTarget);
			templateOneClick($product);			
		})
		
		//Template One Click Popup
		function templateOneClick(item){
			$.magnificPopup.open({
				type : 'inline',
				callbacks: {
					open: function() {
						$('#nameoneclick-main').keypress(event => (event.key).match(/^[A-Za-zȘȚÎĂÂșțăîâа-яА-ЯёЁ\s]+$/) ? true : false);
						$('#phoneoneclick-main').keypress(event => (event.key).match(/^[+()\d-]+$/) ? true : false);
						$('#textareaoneclick-main').keypress(event => (event.key).match(/^[A-Za-zȘȚÎĂÂșțăîâа-яА-ЯёЁ0-9.,\s]+$/) ? true : false);
						let bindElements = ['#nameoneclick-main', '#phoneoneclick-main', '#textareaoneclick-main'];
						bindElements.map(element => $(element).bind('copy paste cut', e => e.preventDefault()));						
					}
				},
				items: {
					src :`<div class="modal-content send_message_one_click">
						<div class="wrap_titleoneclick">
							<span class="modal-title">${item.data('title')}</span>
						</div>
						<form class="js-one-click-form-main send_message_one_click_form" method="post" action="${item.data('form-action')}">
							<input type="hidden" name="product_id" value="${item.data('product-id')}">
							<input type="hidden" name="client_id" value="${item.data('client-id')}">
							<div class="wrap_nameoneclick">
								<input class="form-control js-only-letter" id="nameoneclick-main" placeholder="${item.data('input-name')}"  name="customer_name" required>
							</div>
							<div class="wrap_phoneoneclick">
								<input class="form-control" id="phoneoneclick-main" placeholder="${item.data('input-phone')}" type="tel"  name="customer_phone" oninvalid="this.setCustomValidity('${item.data('input-customvalidity')}')" required>
							</div>
							<div class="wrap_areaoneclick">
								<textarea id="textareaoneclick-main" placeholder="${item.data('input-comment')}" class="form-control" rows="4" name="comment" id="js-costumer-comment"></textarea>
							</div>
							<div class="wrap_one_click_form_submit" id="js-btn-block-form-main">
								<button type="submit" id="one-click-form-submit-main" data-callback="submitFuncOneClickBuy">
									${item.data('button-text')}
								</button>
							</div>
							<div class="success_one_click_main text-center d-none">
								<h4>${item.data('success-msg')}</h4>
							</div>
						</form>
					</div>
						`
				}
			})
		}
		
		// Post request after confirm		
		$(document).on('submit', '.js-one-click-form-main', e => {
			e.preventDefault();
			const $this = $(e.currentTarget),
						data  = $this.serialize();
				$.post($this.attr('action'), data, function(resp){
					if(resp.success){
						$('.wrap_titleoneclick').css('border', 'none');
						$('#nameoneclick-main').hide();
						$('#phoneoneclick-main').hide();
						$('#mailoneclick-main').hide();
						$('#textareaoneclick-main').hide();
						$('#js-btn-block-form-main').hide();
						$('.success_one_click_main').removeClass('d-none');						
						setTimeout(() => {
							$.magnificPopup.close()
						}, 4000)
					}
			});
		});		
	}
}
new Btn_oneClickPopup();
